import { render, staticRenderFns } from "./Presentation.vue?vue&type=template&id=0d46a78e&scoped=true&"
import script from "./Presentation.vue?vue&type=script&lang=js&"
export * from "./Presentation.vue?vue&type=script&lang=js&"
import style0 from "./Presentation.vue?vue&type=style&index=0&id=0d46a78e&prod&scoped=true&lang=css&"
import style1 from "./Presentation.vue?vue&type=style&index=1&id=0d46a78e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d46a78e",
  null
  
)

export default component.exports